/**
 * Created by ghanjra on 8/9/2017.
 */

export class GlsConstants {
	public static SUCCESS_STATUS: string = 'success';
	public static RESUBSCRIBE: string = 'add';
	public static UNSUBSCRIBE: string = 'remove';
}
